import { z } from 'zod'

import { schemaModel } from '@/utility'

export enum ExternalAccessMethod {
  Email = 'email',
  SSO = 'sso',
}

export const externalAccessMethodsSchema = z
  .object({
    [ExternalAccessMethod.Email]: z.boolean().default(true),
    [ExternalAccessMethod.SSO]: z.boolean().default(false),
  })
  .meta({ id: 'external-access-methods' })

export type ExternalAccessMethods = z.infer<typeof externalAccessMethodsSchema>

export const externalAccessMethodLabels: {
  [key in ExternalAccessMethod]: string
} = {
  [ExternalAccessMethod.Email]: 'Email Magic Link',
  [ExternalAccessMethod.SSO]: 'Single Sign-On',
}

export const externalAccessSchema = z
  .object({
    /** Available authentication methods for external access */
    methods: externalAccessMethodsSchema.default(
      schemaModel({}, externalAccessMethodsSchema),
    ),
  })
  .meta({ id: 'external-access' })

export type ExternalAccess = z.infer<typeof externalAccessSchema>
